import { connect } from 'react-redux';
import flatten from 'lodash/flatten';
import { playlistActions, RootState, Dispatch } from '../../api';
import Playlist, {
  StateProps,
  DispatchProps,
  OwnProps,
} from '../../components/Modals/Playlist';

export default connect<StateProps, DispatchProps, OwnProps, RootState>(
  ({
    playlists: {
      entries,
      userPlaylists: { data, pagination },
      isRequestingUserPlaylists,
      isCreatingPlaylist,
      errorCreatePlaylist,
    },
  }) => ({
    // used set to prevent duplicate playlists appearing:
    // when multiple pages are present each newly created playlist
    // comes with the then last page
    playlists: Array.from(new Set(flatten(Object.values(data || {})))).map<{
      id: number;
      name: string;
    }>((id: unknown) => ({
      id: id as number,
      name: entries[id as number].name,
    })),
    isSubmitting: isCreatingPlaylist,
    errorMessage: errorCreatePlaylist,
    hasFetchedPlaylists: !isRequestingUserPlaylists && data[1],
    currentPage: pagination ? pagination.currentPage : 1,
    lastPageReached: pagination
      ? pagination.currentPage >= pagination.lastPage
      : false,
  }),
  (dispatch: Dispatch) => ({
    fetchPlaylists: (page, trackId) => {
      dispatch(playlistActions.getUserPlaylists({ page, trackId }));
    },
    addTracktoPlaylist: (playlistId, trackId) => {
      dispatch(playlistActions.addTrack(playlistId, trackId));
    },
    createPlaylist: (name) => {
      dispatch(playlistActions.create(name));
    },
  }),
)(Playlist);
